import { RefObject, useEffect, useLayoutEffect, useState } from 'react'

const useObservedWidth = (ref: RefObject<HTMLElement>) => {
  const [width, setWidth] = useState(1)
  const [element, setElement] = useState<HTMLElement | null>(null)

  // Refs aren't reactive, so track the node itself: components that swap
  // layouts (e.g. mobile vs desktop) point the ref at a different element.
  useLayoutEffect(() => {
    setElement((current) => (current === ref.current ? current : ref.current))
  })

  useEffect(() => {
    if (!element) return
    const updateWidth = () => setWidth(Math.max(element.clientWidth, 1))
    updateWidth()
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateWidth)
      return () => window.removeEventListener('resize', updateWidth)
    }
    const observer = new ResizeObserver(() => updateWidth())
    observer.observe(element)
    return () => observer.disconnect()
  }, [element])

  return width
}

export default useObservedWidth
